<div class="output-settings-format-editor" [class.widget-mode]="isWidgetMode">
  <form
    [formGroup]="formGroup"
    class="output-settings-form"
    [ngClass]="{ disabled: fieldsDisabled }"
  >
    <div class="editor-panes">
      <!-- Left Panel -->
      <div
        class="editor-panes__side"
        [class.editor-panes__side--hidden]="!shouldShowLeftPanel"
      >
        <!-- General Settings Section -->
        <div class="settings-section">
          <div class="section-header">
            <h5 class="section-title">
              {{ "export-setting-popup.section.general-settings" | translate }}
            </h5>
          </div>

          <div class="general-settings-form">
            <!-- Maximum content items -->
            <div class="format-editor__block">
              <label
                for="number_of_posts"
                sui-label
                [ngClass]="{ disabled: fieldsDisabled }"
              >
                {{
                  "export-setting-popup.section.maximum-content-items-to-output"
                    | translate
                }}
              </label>
              <div class="input-container">
                <sui-input
                  type="number"
                  id="number_of_posts"
                  formControlName="number_of_posts"
                  [min]="1"
                ></sui-input>
              </div>
            </div>

            <!-- Template dropdowns (only if format supports templates AND form controls exist) -->
            @if (currentFormat?.has_templates) {
              @for (language of supportedLanguages; track language) {
                @if (formGroup.get("template_" + language.id)) {
                  <div class="format-editor__field">
                    <label [for]="'template_' + language.id" sui-label>
                      {{
                        "export-setting-popup.section.template-for" | translate
                      }}
                      {{ language.name }}
                    </label>
                    <div
                      class="select-container"
                      [ngClass]="{ disabled: fieldsDisabled }"
                    >
                      <sui-combobox
                        [id]="'template_' + language.id"
                        class="select"
                        [formControlName]="'template_' + language.id"
                        [options]="(templateSelectOptions$ | async) ?? []"
                        [placeholder]="
                          'export-setting-popup.select.select-template'
                            | translate
                        "
                        [clearable]="true"
                      ></sui-combobox>
                    </div>
                  </div>
                }
              }
            }

            <!-- General Settings only in left panel -->
            @if (currentFormat?.settings) {
              @for (setting of currentFormat.settings; track setting) {
                <div>
                  @if (setting.id === 1) {
                    <div>
                      <!-- general settings -->
                      @for (
                        settingItem of setting.settings;
                        track settingItem
                      ) {
                        <div
                          [hidden]="searchString && !matches(settingItem.name)"
                        >
                          <!-- TOGGLE type settings -->
                          @if (
                            settingItem.value_type === "TOGGLE" &&
                            formGroup.get(
                              "setting_" +
                                setting.id +
                                "_" +
                                settingItem.id +
                                "_value"
                            )
                          ) {
                            <div class="checkbox">
                              <sui-checkbox
                                [formControlName]="
                                  'setting_' +
                                  setting.id +
                                  '_' +
                                  settingItem.id +
                                  '_value'
                                "
                              >
                                <span
                                  [innerHTML]="
                                    settingItem.name | highlight: searchString
                                  "
                                ></span>
                              </sui-checkbox>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            }
          </div>
        </div>

        <!-- Toggle & Order Layout Elements Section -->
        @if (showComponents) {
          <div class="settings-section">
            <div class="section-header">
              <h5 class="section-title">
                {{
                  "export-setting-popup.section.toggle-&-order-layout-elements"
                    | translate
                }}
              </h5>
            </div>
            <div class="layout-elements-container">
              <div
                cdkDropList
                (cdkDropListDropped)="onLayoutElementDrop($event)"
                class="layout-elements-list"
              >
                @for (element of layoutElements; track element) {
                  <div
                    cdkDrag
                    class="layout-element-item"
                    [hidden]="searchString && !matches(element.name)"
                  >
                    <div class="layout-element-content">
                      <!-- Drag Handle -->
                      <div class="drag-handle" cdkDragHandle>
                        <fa-icon [icon]="['fas', 'grip-vertical']"></fa-icon>
                      </div>
                      <!-- Checkbox -->
                      <div class="checkbox">
                        <sui-checkbox
                          [ngModel]="element.selected"
                          [ngModelOptions]="{ standalone: true }"
                          (checkedChange)="
                            onLayoutElementCheckboxChange(element.id, $event)
                          "
                        >
                          <span
                            [innerHTML]="element.name | highlight: searchString"
                          ></span>
                        </sui-checkbox>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Right Panel -->
      <div
        class="editor-panes__main"
        [class.editor-panes__main--full]="isWidgetMode"
      >
        @if (showInternalTabs) {
          <div class="content-tabs">
            <sui-tabs
              [tabs]="tabItems"
              [value]="activeTab"
              (valueChange)="setActiveTab($event)"
            ></sui-tabs>
            <div>
              <!-- Content Settings Tab -->
              <div [hidden]="!isActiveTab('content')">
                <div class="content-settings">
                  <!-- Content Settings from format.settings -->
                  @for (setting of currentFormat?.settings; track setting) {
                    @if (setting.id == 3) {
                      <div class="settings-group form-group-panel">
                        @for (
                          settingItem of setting.settings;
                          track settingItem
                        ) {
                          <div
                            [hidden]="
                              searchString && !matches(settingItem.name)
                            "
                          >
                            <!-- TOGGLE type settings -->
                            @if (
                              settingItem.value_type === "TOGGLE" &&
                              formGroup.get(
                                "setting_" +
                                  setting.id +
                                  "_" +
                                  settingItem.id +
                                  "_value"
                              )
                            ) {
                              <div
                                class="checkbox"
                                [ngClass]="{ disabled: fieldsDisabled }"
                              >
                                <sui-checkbox
                                  [formControlName]="
                                    'setting_' +
                                    setting.id +
                                    '_' +
                                    settingItem.id +
                                    '_value'
                                  "
                                >
                                  <span
                                    [innerHTML]="
                                      settingItem.name | highlight: searchString
                                    "
                                  ></span>
                                </sui-checkbox>
                              </div>
                            }
                            <!-- LIST type settings -->
                            @if (
                              settingItem.value_type === "LIST" &&
                              formGroup.get(
                                "setting_" +
                                  setting.id +
                                  "_" +
                                  settingItem.id +
                                  "_value"
                              )
                            ) {
                              <div class="format-editor__field">
                                <label
                                  sui-label
                                  [ngClass]="{ disabled: fieldsDisabled }"
                                  [innerHTML]="
                                    settingItem.name | highlight: searchString
                                  "
                                ></label>
                                <div
                                  class="select-container"
                                  [ngClass]="{ disabled: fieldsDisabled }"
                                >
                                  <sui-combobox
                                    class="select"
                                    [ngClass]="{ disabled: fieldsDisabled }"
                                    [formControlName]="
                                      'setting_' +
                                      setting.id +
                                      '_' +
                                      settingItem.id +
                                      '_value'
                                    "
                                    [options]="
                                      settingItem.values | comboboxOptions
                                    "
                                  ></sui-combobox>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  }
                  <!-- Dynamic Properties Grid -->
                  @if (
                    currentFormat?.properties &&
                    currentFormat.properties.length > 0
                  ) {
                    <div class="settings-group form-group-panel">
                      <h6>
                        {{
                          "export-setting-popup.section.toggle-content-properties"
                            | translate
                        }}
                      </h6>
                      <div class="properties-grid">
                        @for (column of propertiesColumns; track column) {
                          <div class="properties-column">
                            @for (group of column; track group) {
                              <div
                                class="property-group"
                                [hidden]="
                                  searchString && !groupHasMatches(group)
                                "
                              >
                                <div class="group-header">
                                  <sui-checkbox
                                    [disabled]="fieldsDisabled"
                                    (checkedChange)="toggleGroup(group, $event)"
                                  >
                                    <strong
                                      [innerHTML]="
                                        group.label | highlight: searchString
                                      "
                                    ></strong>
                                  </sui-checkbox>
                                </div>
                                <div class="group-content ml-3">
                                  @for (
                                    property of group.properties;
                                    track property
                                  ) {
                                    <div
                                      class="property-row"
                                      [hidden]="
                                        searchString && !matches(property.title)
                                      "
                                    >
                                      <div class="checkbox">
                                        <sui-checkbox
                                          [formControlName]="
                                            'property_' +
                                            property.key +
                                            '_value'
                                          "
                                          (checkedChange)="
                                            togglePropertyControl(property)
                                          "
                                        >
                                          <span
                                            class="ml-2"
                                            [class.font-weight-bold]="
                                              property.values
                                            "
                                            [innerHTML]="
                                              property.title
                                                | highlight: searchString
                                            "
                                          ></span>
                                        </sui-checkbox>
                                      </div>
                                      @if (
                                        property.values &&
                                        property.values.length > 0
                                      ) {
                                        <div class="format-editor__sub">
                                          <sui-combobox
                                            [options]="
                                              property.values | comboboxOptions
                                            "
                                            [multiple]="false"
                                            placeholder="Select options..."
                                            [formControlName]="
                                              'property_' +
                                              property.key +
                                              '_property_value'
                                            "
                                            [readonly]="
                                              formGroup.get(
                                                'property_' +
                                                  property.key +
                                                  '_value'
                                              )?.value === false
                                            "
                                            class="custom-select-sm"
                                          ></sui-combobox>
                                          @if (
                                            formGroup.get(
                                              "property_" +
                                                property.key +
                                                "_value"
                                            )?.value === false
                                          ) {
                                            <small class="text-muted">
                                              Check the box above to enable
                                              selection
                                            </small>
                                          }
                                        </div>
                                      }
                                      @if (
                                        property.options &&
                                        property.options.length > 0
                                      ) {
                                        <div class="property-options">
                                          @for (
                                            option of property.options;
                                            track option
                                          ) {
                                            <div class="format-editor__field">
                                              <label
                                                sui-label
                                                [for]="
                                                  'property_' +
                                                  property.key +
                                                  '_option_' +
                                                  option.key
                                                "
                                              >
                                                {{ option.label }}
                                              </label>
                                              @if (
                                                option.input_type === "integer"
                                              ) {
                                                <sui-input
                                                  type="number"
                                                  [id]="
                                                    'property_' +
                                                    property.key +
                                                    '_option_' +
                                                    option.key
                                                  "
                                                  [formControlName]="
                                                    'property_' +
                                                    property.key +
                                                    '_option_' +
                                                    option.key
                                                  "
                                                  [min]="option.min"
                                                  [max]="option.max"
                                                  [disabled]="
                                                    fieldsDisabled ||
                                                    formGroup.get(
                                                      'property_' +
                                                        property.key +
                                                        '_value'
                                                    )?.value === false
                                                  "
                                                ></sui-input>
                                              }
                                              @if (
                                                option.input_type === "enum"
                                              ) {
                                                <sui-combobox
                                                  [options]="
                                                    option.choices
                                                      | comboboxOptions
                                                  "
                                                  [formControlName]="
                                                    'property_' +
                                                    property.key +
                                                    '_option_' +
                                                    option.key
                                                  "
                                                  [readonly]="
                                                    fieldsDisabled ||
                                                    formGroup.get(
                                                      'property_' +
                                                        property.key +
                                                        '_value'
                                                    )?.value === false
                                                  "
                                                  class="custom-select-sm"
                                                ></sui-combobox>
                                              }
                                            </div>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <!-- Empty state if no properties -->
                  @if (
                    !currentFormat?.properties ||
                    currentFormat.properties.length === 0
                  ) {
                    <sui-empty-state
                      [title]="
                        'export-setting-popup.section.no-content-properties-available-for-this-format'
                          | translate
                      "
                    ></sui-empty-state>
                  }
                </div>
              </div>
              <!-- Widget Settings Tab -->
              @if (
                currentFormat?.settings && currentFormat.settings.length > 0
              ) {
                <div [hidden]="!isActiveTab('widget')">
                  <div class="widget-settings">
                    <!-- Widget Settings Groups -->
                    @for (setting of currentFormat.settings; track setting) {
                      @if (setting.id === 2) {
                        <div class="settings-group form-group-panel">
                          @for (
                            settingItem of setting.settings;
                            track settingItem
                          ) {
                            <div
                              [hidden]="
                                searchString && !matches(settingItem.name)
                              "
                            >
                              <!-- TOGGLE type settings -->
                              @if (
                                settingItem.value_type === "TOGGLE" &&
                                formGroup.get(
                                  "setting_" +
                                    setting.id +
                                    "_" +
                                    settingItem.id +
                                    "_value"
                                )
                              ) {
                                <div
                                  class="checkbox"
                                  [ngClass]="{ disabled: fieldsDisabled }"
                                >
                                  <sui-checkbox
                                    [formControlName]="
                                      'setting_' +
                                      setting.id +
                                      '_' +
                                      settingItem.id +
                                      '_value'
                                    "
                                  >
                                    <span
                                      [innerHTML]="
                                        settingItem.name
                                          | highlight: searchString
                                      "
                                    ></span>
                                  </sui-checkbox>
                                </div>
                              }
                              <!-- LIST type settings -->
                              @if (
                                settingItem.value_type === "LIST" &&
                                formGroup.get(
                                  "setting_" +
                                    setting.id +
                                    "_" +
                                    settingItem.id +
                                    "_value"
                                )
                              ) {
                                <div
                                  class="format-editor__field"
                                  [ngClass]="{
                                    disabled:
                                      fieldsDisabled ||
                                      isSettingGated(
                                        setting.id,
                                        settingItem.id
                                      ),
                                  }"
                                >
                                  <label
                                    sui-label
                                    [ngClass]="{
                                      disabled:
                                        fieldsDisabled ||
                                        isSettingGated(
                                          setting.id,
                                          settingItem.id
                                        ),
                                    }"
                                    [innerHTML]="
                                      settingItem.name | highlight: searchString
                                    "
                                  ></label>
                                  <div
                                    class="select-container"
                                    [ngClass]="{
                                      disabled:
                                        fieldsDisabled ||
                                        isSettingGated(
                                          setting.id,
                                          settingItem.id
                                        ),
                                    }"
                                  >
                                    <sui-combobox
                                      class="select"
                                      [ngClass]="{
                                        disabled:
                                          fieldsDisabled ||
                                          isSettingGated(
                                            setting.id,
                                            settingItem.id
                                          ),
                                      }"
                                      [formControlName]="
                                        'setting_' +
                                        setting.id +
                                        '_' +
                                        settingItem.id +
                                        '_value'
                                      "
                                      [options]="
                                        settingItem.values | comboboxOptions
                                      "
                                      [readonly]="
                                        isSettingGated(
                                          setting.id,
                                          settingItem.id
                                        )
                                      "
                                    ></sui-combobox>
                                  </div>
                                </div>
                              }
                              <!-- INPUT_NUMBER type settings -->
                              @if (
                                settingItem.value_type === "INPUT_NUMBER" &&
                                formGroup.get(
                                  "setting_" +
                                    setting.id +
                                    "_" +
                                    settingItem.id +
                                    "_value"
                                )
                              ) {
                                <div
                                  class="format-editor__field"
                                  [ngClass]="{ disabled: fieldsDisabled }"
                                >
                                  <label
                                    sui-label
                                    [ngClass]="{ disabled: fieldsDisabled }"
                                    [innerHTML]="
                                      settingItem.name | highlight: searchString
                                    "
                                  ></label>
                                  <div class="input-container">
                                    <sui-input
                                      type="number"
                                      [formControlName]="
                                        'setting_' +
                                        setting.id +
                                        '_' +
                                        settingItem.id +
                                        '_value'
                                      "
                                      [min]="1"
                                    ></sui-input>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <!-- Widget mode / level -->
        @if (!showInternalTabs) {
          <div class="direct-content">
            @if (showProperties) {
              <div class="content-settings">
                <!-- ✅ Properties Section - Widget level -->
                @if (
                  currentFormat?.properties &&
                  currentFormat.properties.length > 0
                ) {
                  <div class="settings-group form-group-panel">
                    <h6>
                      {{
                        "export-setting-popup.section.toggle-content-properties"
                          | translate
                      }}
                    </h6>
                    <label
                      for="number_of_posts"
                      sui-label
                      [ngClass]="{ disabled: fieldsDisabled }"
                    >
                      {{
                        "export-setting-popup.section.maximum-content-items-to-output"
                          | translate
                      }}
                    </label>
                    <div class="input-container">
                      <sui-input
                        type="number"
                        id="number_of_posts"
                        formControlName="number_of_posts"
                        [min]="1"
                      ></sui-input>
                    </div>
                    <div class="properties-grid">
                      @for (column of propertiesColumns; track column) {
                        <div class="properties-column">
                          @for (group of column; track group) {
                            <div
                              class="property-group"
                              [hidden]="searchString && !groupHasMatches(group)"
                            >
                              <div class="group-header">
                                <sui-checkbox
                                  [disabled]="fieldsDisabled"
                                  (checkedChange)="toggleGroup(group, $event)"
                                >
                                  <strong
                                    [innerHTML]="
                                      group.label | highlight: searchString
                                    "
                                  ></strong>
                                </sui-checkbox>
                              </div>
                              <div class="group-content ml-3">
                                @for (
                                  property of group.properties;
                                  track property
                                ) {
                                  <div
                                    class="property-row"
                                    [hidden]="
                                      searchString && !matches(property.title)
                                    "
                                  >
                                    <div class="checkbox">
                                      <sui-checkbox
                                        [formControlName]="
                                          'property_' + property.key + '_value'
                                        "
                                        (checkedChange)="
                                          togglePropertyControl(property)
                                        "
                                      >
                                        <span
                                          class="ml-2"
                                          [class.font-weight-bold]="
                                            property.values
                                          "
                                          [innerHTML]="
                                            property.title
                                              | highlight: searchString
                                          "
                                        ></span>
                                      </sui-checkbox>
                                    </div>
                                    @if (
                                      property.values &&
                                      property.values.length > 0
                                    ) {
                                      <div class="format-editor__sub">
                                        <sui-combobox
                                          [options]="
                                            property.values | comboboxOptions
                                          "
                                          [multiple]="false"
                                          placeholder="Select options..."
                                          [formControlName]="
                                            'property_' +
                                            property.key +
                                            '_property_value'
                                          "
                                          [readonly]="
                                            formGroup.get(
                                              'property_' +
                                                property.key +
                                                '_value'
                                            )?.value === false
                                          "
                                          class="custom-select-sm"
                                        ></sui-combobox>
                                        @if (
                                          formGroup.get(
                                            "property_" +
                                              property.key +
                                              "_value"
                                          )?.value === false
                                        ) {
                                          <small class="text-muted">
                                            Check the box above to enable
                                            selection
                                          </small>
                                        }
                                      </div>
                                    }
                                    @if (
                                      property.options &&
                                      property.options.length > 0
                                    ) {
                                      <div class="property-options">
                                        @for (
                                          option of property.options;
                                          track option
                                        ) {
                                          <div class="format-editor__field">
                                            <label
                                              sui-label
                                              [for]="
                                                'property_' +
                                                property.key +
                                                '_option_' +
                                                option.key
                                              "
                                            >
                                              {{ option.label }}
                                            </label>
                                            @if (
                                              option.input_type === "integer"
                                            ) {
                                              <sui-input
                                                type="number"
                                                [id]="
                                                  'property_' +
                                                  property.key +
                                                  '_option_' +
                                                  option.key
                                                "
                                                [formControlName]="
                                                  'property_' +
                                                  property.key +
                                                  '_option_' +
                                                  option.key
                                                "
                                                [min]="option.min"
                                                [max]="option.max"
                                                [disabled]="
                                                  fieldsDisabled ||
                                                  formGroup.get(
                                                    'property_' +
                                                      property.key +
                                                      '_value'
                                                  )?.value === false
                                                "
                                              ></sui-input>
                                            }
                                            @if (option.input_type === "enum") {
                                              <sui-combobox
                                                [options]="
                                                  option.choices
                                                    | comboboxOptions
                                                "
                                                [formControlName]="
                                                  'property_' +
                                                  property.key +
                                                  '_option_' +
                                                  option.key
                                                "
                                                [readonly]="
                                                  fieldsDisabled ||
                                                  formGroup.get(
                                                    'property_' +
                                                      property.key +
                                                      '_value'
                                                  )?.value === false
                                                "
                                                class="custom-select-sm"
                                              ></sui-combobox>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
                <!-- ✅ Settings Section -> for future use!!! Currently we do not show them -->
                @if (showSettings) {
                  <div class="widget-settings">
                    @for (setting of currentFormat?.settings; track setting) {
                      @if (setting.id == 3) {
                        <div class="settings-group form-group-panel">
                          <h6>{{ setting.name }}</h6>
                          @for (
                            settingItem of setting.settings;
                            track settingItem
                          ) {
                            <div
                              [hidden]="
                                searchString && !matches(settingItem.name)
                              "
                            >
                              <!-- TOGGLE type settings -->
                              @if (
                                settingItem.value_type === "TOGGLE" &&
                                formGroup.get(
                                  "setting_" +
                                    setting.id +
                                    "_" +
                                    settingItem.id +
                                    "_value"
                                )
                              ) {
                                <div
                                  class="checkbox"
                                  [ngClass]="{ disabled: fieldsDisabled }"
                                >
                                  <sui-checkbox
                                    [formControlName]="
                                      'setting_' +
                                      setting.id +
                                      '_' +
                                      settingItem.id +
                                      '_value'
                                    "
                                  >
                                    <span
                                      [innerHTML]="
                                        settingItem.name
                                          | highlight: searchString
                                      "
                                    ></span>
                                  </sui-checkbox>
                                </div>
                              }
                              <!-- LIST type settings -->
                              @if (
                                settingItem.value_type === "LIST" &&
                                formGroup.get(
                                  "setting_" +
                                    setting.id +
                                    "_" +
                                    settingItem.id +
                                    "_value"
                                )
                              ) {
                                <div class="format-editor__field">
                                  <label
                                    sui-label
                                    [ngClass]="{ disabled: fieldsDisabled }"
                                    [innerHTML]="
                                      settingItem.name | highlight: searchString
                                    "
                                  ></label>
                                  <div
                                    class="select-container"
                                    [ngClass]="{ disabled: fieldsDisabled }"
                                  >
                                    <sui-combobox
                                      class="select"
                                      [formControlName]="
                                        'setting_' +
                                        setting.id +
                                        '_' +
                                        settingItem.id +
                                        '_value'
                                      "
                                      [options]="
                                        settingItem.values | comboboxOptions
                                      "
                                    ></sui-combobox>
                                  </div>
                                </div>
                              }
                              <!-- INPUT_NUMBER type settings -->
                              @if (
                                settingItem.value_type === "INPUT_NUMBER" &&
                                formGroup.get(
                                  "setting_" +
                                    setting.id +
                                    "_" +
                                    settingItem.id +
                                    "_value"
                                )
                              ) {
                                <div
                                  class="format-editor__field"
                                  [ngClass]="{ disabled: fieldsDisabled }"
                                >
                                  <label
                                    sui-label
                                    [ngClass]="{ disabled: fieldsDisabled }"
                                    [innerHTML]="
                                      settingItem.name | highlight: searchString
                                    "
                                  ></label>
                                  <div class="input-container">
                                    <sui-input
                                      type="number"
                                      [formControlName]="
                                        'setting_' +
                                        setting.id +
                                        '_' +
                                        settingItem.id +
                                        '_value'
                                      "
                                      [min]="1"
                                    ></sui-input>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    }
                  </div>
                }
                <!-- Empty state if no properties -->
                @if (
                  !currentFormat?.properties ||
                  currentFormat.properties.length === 0
                ) {
                  <sui-empty-state
                    [title]="
                      'export-setting-popup.section.no-content-properties-available-for-this-format'
                        | translate
                    "
                  ></sui-empty-state>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </form>
</div>
